import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import React from 'react';
import FileFormContainer from '../../containers/files/FileFormContainer.jsx';
import requireAuth from '../../lib/requireAuth.jsx';
import withRouterParams from '../../lib/withRouterParams.jsx';

const EditFile = ({ slug, fileId }) => (
  <>
    <Helmet>
      <title>Edit Linked File | ChangeSync</title>
    </Helmet>
    <FileFormContainer
      title="Edit Linked File"
      fileId={fileId}
      slug={slug}
      isEditing
    />
  </>
);

EditFile.getInitialProps = ({ query }) => ({
  slug: query.slug,
  fileId: Number(query.fileId),
});

EditFile.propTypes = {
  fileId: PropTypes.number.isRequired,
};

export default requireAuth(withRouterParams(EditFile));
